 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXT9781607051671_01_TIT from '@/components/Text/9781607051671_01_tit'
 import TEXT9781607051671_02_CPY from '@/components/Text/9781607051671_02_cpy'
 import TEXT9781607051671_03_DED from '@/components/Text/9781607051671_03_ded'
 import TEXT9781607051671_04_ACK from '@/components/Text/9781607051671_04_ack'
 import TEXT9781607051671_05_TOC from '@/components/Text/9781607051671_05_toc'
 import TEXT9781607051671_06_PRE from '@/components/Text/9781607051671_06_pre'
 import TEXT9781607051671_07_INT from '@/components/Text/9781607051671_07_int'
 import TEXT9781607051671_08_BOO from '@/components/Text/9781607051671_08_boo'
 import TEXT9781607051671_09_BAS from '@/components/Text/9781607051671_09_bas'
 import TEXT9781607051671_10_PT01 from '@/components/Text/9781607051671_10_pt01'
 import TEXT9781607051671_11_PT02 from '@/components/Text/9781607051671_11_pt02'
 import TEXT9781607051671_12_PT03 from '@/components/Text/9781607051671_12_pt03'
 import LOVE_2 from '@/components/love_2'
 import TEXT9781607051671_13_GAL from '@/components/Text/9781607051671_13_gal'
 import TEXT9781607051671_14_AUT from '@/components/Text/9781607051671_14_aut'
 import TEXT9781607051671_15_ADD from '@/components/Text/9781607051671_15_add'
 import TEXT9781607051671_16_SAM from '@/components/Text/9781607051671_16_sam'
 import TEXT9781607051671_17_CPY1 from '@/components/Text/9781607051671_17_cpy1'
 import TEXT9781607051671_18_ADD1 from '@/components/Text/9781607051671_18_add1'
 import TEXT9781607051671_19_BC from '@/components/Text/9781607051671_19_bc'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/9781607051671_05_toc",
 			"name" : "Text/9781607051671_05_toc",
 			"component" : TEXT9781607051671_05_TOC
 		},
 		{
 			"path" : "/Text/9781607051671_06_pre",
 			"name" : "Text/9781607051671_06_pre",
 			"component" : TEXT9781607051671_06_PRE
 		},
 		{
 			"path" : "/Text/9781607051671_07_int",
 			"name" : "Text/9781607051671_07_int",
 			"component" : TEXT9781607051671_07_INT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js